import styled from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Photobox = styled.label`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;

  ${Media.sm`
    margin: 0 auto;
  `}
`;

export const PhotoHolder = styled.div`
  display: flex;
  width: 255px;
  height: 255px;
  margin: 0 auto 15px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  border: 6px solid ${(props) => props.theme.border};
  overflow: hidden;
`;

export const Photo = styled.img`
  display: block;
  width: 220px;
  height: 220px;
  object-fit: cover;
  border-radius: 15px;
  background: ${(props) => props.theme.background};
`;

export const PhotoPlaceholder = styled.div`
  display: block;
  width: 220px;
  height: 220px;
  object-fit: cover;
  border-radius: 15px;
  background: ${(props) => props.theme.background};
`;

export const Text = styled.span`
  display: inline-block;
  transition: 0.2s color;
  margin-bottom: 5px;
  color: ${(props) => props.theme.color};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  word-break: break-word;

  label:hover & {
    color: ${(props) => props.theme.colorOnHover};
  }
`;

export const Input = styled.input`
  display: none;
`;

export const Info = styled.span`
  display: inline-block;
  font-size: 10px;
  font-weight: 300;
  line-height: 1.4;
  text-align: left;
  cursor: default;

  ${Media.sm`
    padding: 5px 10px;
  `}
`;

export const Button = styled.a`
  ${commonButton}
`;
